var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_119844)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1546_119844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 19.8705C40 26.7631 34.3926 32.3705 27.5 32.3705H8.64281L13.971 37.6987C14.3371 38.0648 14.3371 38.6584 13.971 39.0246L13.5291 39.4664C13.163 39.8325 12.5695 39.8325 12.2033 39.4664L4.52023 31.7834C4.15414 31.4173 4.15414 30.8237 4.52023 30.4575L12.2033 22.7745C12.5694 22.4084 13.163 22.4084 13.5291 22.7745L13.971 23.2164C14.3371 23.5825 14.3371 24.1761 13.971 24.5422L8.64281 29.8705H27.5C33.014 29.8705 37.5 25.3845 37.5 19.8705C37.5 17.6396 36.7654 15.5774 35.5257 13.9121C35.247 13.5377 35.2821 13.0166 35.6121 12.6866L36.0578 12.2409C36.4609 11.8378 37.1264 11.8857 37.4705 12.3402C39.0574 14.436 40 17.0451 40 19.8705ZM4.4743 25.8289C3.23461 24.1636 2.5 22.1014 2.5 19.8705C2.5 14.3565 6.98602 9.87051 12.5 9.87051H31.3572L26.029 15.1987C25.6629 15.5648 25.6629 16.1584 26.029 16.5246L26.4709 16.9664C26.837 17.3325 27.4305 17.3325 27.7967 16.9664L35.4798 9.2834C35.8459 8.9173 35.8459 8.32371 35.4798 7.95754L27.7968 0.27457C27.4307 -0.0915234 26.8371 -0.0915234 26.4709 0.27457L26.0291 0.716445C25.663 1.08254 25.663 1.67613 26.0291 2.0423L31.3572 7.37051H12.5C5.60742 7.37051 0 12.9779 0 19.8705C0 22.6959 0.942578 25.305 2.52937 27.4007C2.87352 27.8553 3.53898 27.9032 3.94211 27.5L4.38781 27.0543C4.71789 26.7243 4.75297 26.2033 4.4743 25.8289V25.8289Z",
    fill: "#61A578"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_119844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1546_119844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.bbde98d669ebeb9de31f5ed53135910c.svg";
export { ForwardRef as ReactComponent };